import { FC, memo } from 'react'
import { RelatedInfoTable } from './components/relatedInfoTable/relatedInfoTable'

export const TaskDetailRelatedInfoListPanel: FC = memo(() => {
  return (
    <div className="px-2.5 overflow-y-auto">
      {/* 関連情報テーブルの表示 */}
      <RelatedInfoTable />
    </div>
  )
})
